"use client"
import type { Client } from "@opensea/graphql"
import { prefetch } from "@opensea/graphql"
import { TOP_CURRENCY_STATS_TABLE_PAGE_SIZE } from "./constants"
import { TopCurrencyStatsTableQuery } from "./query"

export const prefetchCurrencyStats = (client: Client) => {
  prefetch(client, TopCurrencyStatsTableQuery, {
    limit: TOP_CURRENCY_STATS_TABLE_PAGE_SIZE,
    sort: { by: "ONE_DAY_VOLUME", direction: "DESC" },
    filter: {},
  })
}
